import { render } from "./BuyButton.vue?vue&type=template&id=06678431&scoped=true"
import script from "./BuyButton.vue?vue&type=script&lang=js"
export * from "./BuyButton.vue?vue&type=script&lang=js"

import "./BuyButton.vue?vue&type=style&index=0&id=06678431&scoped=true&lang=scss"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06678431"]])

export default __exports__